import * as React from "react";
import CollectionsTemplate from "../../../components/CollectionsTemplate";
import EmptyComponent from "../../../utils/EmptyComponent";
import CheckListQuestionControls from "./CheckListQuestionControls";
import { isArray } from "lodash";
import BaseURL from "../../../utils/base-uri.json";
import axios from "../../../utils/fvAxios";
import { useState, useContext, useEffect } from "react";
import ChecklistQuestionDetailsItem from "./ChecklistQuestionDetailsItem";
import QuestionBankTransfer from "../QuestionBankTransfer";
import { Link } from "react-router-dom";
import { Card, Grid, Box, Select, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import Button from "../../../toolkit/ButtonV1";
import { ChecklistContext } from "../../../store/checklist-context";

function toQueryString(obj) {
  return "?".concat(
    Object.keys(obj)
      .map((e) => {
        if (isArray(obj[e])) {
          var d = obj[e]?.map(
            (r, idx) => `${e}[${idx}]=${encodeURIComponent(r)}`
          );
          return d.join("&");
        }
        return obj[e]
          ? `${encodeURIComponent(e)}=${encodeURIComponent(obj[e])}`
          : null;
      })
      .filter((e) => !!e)
      .join("&")
  );
}

function getUrl(url, data) {
  return `${url}${toQueryString(data)}`;
}

export default function CheckListQuestions({
  checklistSubSectionId,
  details,
  templateId,
}) {
  const [originalcollection, setOriginalCollection] = useState({});
  const [temporarycollection, setTemporaryCollection] = useState({});
  const queryUrl = BaseURL.baseUrl + BaseURL.templateTool.GetChecklistQuestions;
  const [allowReorder, setAllowReorder] = useState(false);
  const [temporaryOrderedcollection, setTemporaryOrderedCollection] = useState([]);
  const [blankQuestion, setBlankQuestion] = useState(null);
  const [Trg, setTrg] = useState(false);

  const { recentlySavedQuestion, refreshCollection } =
    useContext(ChecklistContext);

  const SaveReorder = () => {
    setAllowReorder(false);
    setOriginalCollection(temporaryOrderedcollection);
    setTemporaryCollection(temporaryOrderedcollection);
    axios.post(BaseURL.templateTool.ReorderCheckListQuestions, temporaryOrderedcollection?.rows)
      .then((response) => { });
  };

  function checklistQuestionDataAdaptor(data) {
    return {
      headers: [
        { id: "questiondetails", text: "Question Details", width: "50%" },
        { id: "questionType", text: "Question Type", width: "20%" },
        { id: "columns", text: "Input Columns", width: "25%" },
        { id: "icons", text: "Actions", width: "10%" },
      ],
      isEditable: {
        callback: (item) => { },
        isVisible: false,
      },
      isDeletable: {
        callback: (item) => { },
        isVisible: false,
      },
      rows: data?.map((d, i) =>
        Object.assign({}, d, {
          key: d.checklistQuestionId,
          templateId: templateId,
          index: i,
        })
      ),
      statusRoleMap: {
        Active: {
          role: "success",
        },
        InActive: {
          role: "error",
        },
      },
    };
  }

  const startReordering = async () => {
    setAllowReorder(true);
    const resp = await fetchCheckListQuestions();
    if (resp) {
      setOriginalCollection(checklistQuestionDataAdaptor(resp));
      setTemporaryOrderedCollection(checklistQuestionDataAdaptor(resp));
    }
  };

  const handleOrderChange = (data) => {
    setTemporaryOrderedCollection(checklistQuestionDataAdaptor(data));
  };

  const cancelReoder = () => {
    setAllowReorder(false);
    setTemporaryOrderedCollection([]);
    setTemporaryCollection(originalcollection);
  };


  const fetchCheckListQuestions = async () => {
    try {
      const response = await axios.get(
        getUrl(queryUrl, { checklistSubSectionId: checklistSubSectionId })
      );
      if (response?.data?.status === false) {
        console.error(response?.data);
      }
      if (response?.data?.data) {
        return response.data.data;
      }
    } catch (err) {
      console.error(err);
    }
    return null;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resp = await fetchCheckListQuestions();
        if (resp) {
          setOriginalCollection(checklistQuestionDataAdaptor(resp));
          setTemporaryCollection(checklistQuestionDataAdaptor(resp));
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, [refreshCollection, Trg]);

  useEffect(() => {
    if (recentlySavedQuestion.id > 0) {
      setTemporaryCollection((prevCollection) => {
        const previousRows = prevCollection?.rows;

        const updatedRows = previousRows?.map((item, index) => {
          if (recentlySavedQuestion.index === index) {
            return { ...item, checklistQuestionId: recentlySavedQuestion.id };
          }
          return item;
        });

        return {
          ...prevCollection,
          rows: updatedRows,
        };
      });
    }
  }, [recentlySavedQuestion]);

  const handleNewQuestionTransfer = (selectedQuestions) => {
    var newSelected = selectedQuestions;

    var newChecklistQuestion = newSelected.map((element, i) => ({
      checklistQuestionText: element?.questionString,
      numberOfColumns: 1,
      isMandatory: true,
      isVisible: true,
      isBold: true,
      isNoteBold: true,
      questionBankId: element?.questionBankId,
      hasHighlights: false,
      checklistQuestionColumnDetails: [],
      key: i + temporarycollection?.rows?.length ?? 100,
      checklistSubSectionId: checklistSubSectionId,
      templateId: templateId,
      hasUserInput: element.hasUserInput ?? false,
      index: i + temporarycollection?.rows?.length ?? 0,
    }));

    setTemporaryCollection((prevCollection) => {
      const previousRows = [...prevCollection?.rows];
      newChecklistQuestion.map((ele, index) =>
        previousRows.push({ ...ele, isNewAdd: true })
      );
      return {
        ...prevCollection,
        rows: previousRows,
      };
    });
  };
  const handleSelectedQuestionRemoval = (removedQuestions) => {

    const questionBankIdsToRemove = removedQuestions.map((x) => x.questionBankId);

    const questionIdsIndex = removedQuestions.map((x) => x.index);
    const questionsToRemove = removedQuestions.filter((question) => question.preSaved === true);

    const questionIdsToRemove = questionsToRemove.map((x) => x.checklistQuestionId);

    if (questionIdsToRemove?.length > 0)
      DeleteQuestions(questionIdsToRemove);
    setTemporaryCollection((prevCollection) => {
      const previousRows = prevCollection?.rows;

      // const updatedRows = previousRows.filter((row) => {
      //   // Check both conditions: questionBankId and checklistQuestionId
      //   return (
      //     !questionBankIdsToRemove.includes(row.questionBankId) ||
      //     !(
      //       questionIdsToRemove.includes(row.checklistQuestionId) &&
      //       row.checklistQuestionId > 0
      //     )
      //   );
      // });

      const updatedRows = [];
      previousRows.forEach((row, index) => {
        let shouldKeep = true;

        // if (
        //   row.checklistQuestionId > 0 &&
        //   questionIdsToRemove.includes(row.checklistQuestionId)
        // ) {
        //   shouldKeep = false;
        //   console.log(row);
        // } else if (
        //   !row.checklistQuestionId > 0 &&
        //   questionBankIdsToRemove.includes(row.questionBankId)
        //   ) {
        //   console.log(row);
        //   shouldKeep = false;
        // }
        if (!questionIdsIndex.includes(index))
          updatedRows.push(row);

      });

      return {
        ...prevCollection,
        rows: updatedRows,
      };
    });
  };
  const DeleteQuestions = (questionIds) => {
    axios
      .post(BaseURL.templateTool.DeleteChecklistQuestions, questionIds)
      .then((response) => { });
  };
  const addBlankQuestion = () => {
    if (blankQuestion) {
      let newlyAdded = [];
      newlyAdded.push(blankQuestion);
      handleNewQuestionTransfer(newlyAdded);
    } else {
      console.error("No Blank question found.");
    }
  };
  return (
    <>
      <QuestionBankTransfer
        alreadySelectedQuestions={temporarycollection?.rows}
        handleNewQuestionTransfer={handleNewQuestionTransfer}
        handleSelectedQuestionRemoval={handleSelectedQuestionRemoval}
        blankQuestion={blankQuestion}
        setBlankQuestion={setBlankQuestion}
      />
      <Box
        className="mt-3 bg-white rounded border p-0"
        style={{ padding: "16px" }}
        sx={{ "& h1": { m: 0 } }}
      >
        <div className="row px-3 pt-3">
          <div className="col-md-3">
            <div>
              <h3 style={{ marginRight: "auto" }}>{details?.subSectionName}</h3>
            </div>
          </div>
          <div className="col-md-4 d-flex justify-content-end">
            <div>
              {originalcollection?.rows?.length > 0 &&
                (allowReorder ? (
                  <>
                    <Button
                      sx={{ minWidth: "120px" }}
                      role="secondary"
                      size="large"
                      label="Cancel"
                      onClick={cancelReoder}
                      className="me-2"
                    />

                    <Button
                      sx={{ minWidth: "120px" }}
                      role="secondary"
                      size="large"
                      label="Done"
                      onClick={SaveReorder}
                    />
                  </>
                ) : (
                  <Grid item>
                    <Button
                      sx={{ minWidth: "130px" }}
                      role="secondary"
                      size="large"
                      label="Re-Arrange"
                      onClick={startReordering}
                    />
                  </Grid>
                ))}
            </div>
          </div>
          <div className="col-md-5 d-flex justify-content-end">
            <div>
              <Button
                sx={{ minWidth: "130px" }}
                role="primary"
                size="large"
                label="Add blank Question"
                onClick={addBlankQuestion}
              />
            </div>
          </div>
        </div>



        <CollectionsTemplate
          TitlebarChildren={EmptyComponent}
          fetchState={{ isLoading: false }}
          collection={allowReorder ? originalcollection : temporarycollection}
          viewType={"list"}
          responseDataAdaptor={checklistQuestionDataAdaptor}
          ListItemComponent={ChecklistQuestionDetailsItem}
          GridItemComponent={EmptyComponent}
          isReodering={allowReorder}
          setTrg={setTrg}
          Trg={Trg}
          reOrderedData={handleOrderChange}
        // CollectionControls={(props) => <CheckListQuestionControls />}
        />
      </Box>
    </>
  );
}
